import { useRefresh } from "lib/@hooks/useRefresh"
import { useMemo, useState } from "react"
import { Bound } from "lib/@components/binding/Bound"
import { Box, Card, List, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { Schedules } from "routes/regime/plugins/zero-u-wizard/schedules"
import { Skills } from "routes/regime/plugins/zero-u-wizard/skills"
import { Repeat } from "lib/@components/repeat"
import { CountEntry } from "routes/regime/plugins/zero-u-wizard/count-entry"
import { summariseBy } from "routes/regime/plugins/zero-u-wizard/summarise-by"
import { Tailorable } from "routes/regime/plugins/zero-u-wizard/tailorable"
import Iconify from "minimals-template/components/Iconify"

export function TaskEntry({ item: { task, count, list, frequency, minutes } }) {
    const refresh = useRefresh()
    const [target] = useState({})
    const skills = list.map("skill").unique()
    const [portal, setPortal] = useState(null)
    const schedules = list.map("schedule._id").unique()
    const rows = useMemo(produceTailoringRows, [list, target.schedulesOpen, target.skillsOpen])

    return (
        <Bound portal={portal} onChange={refresh} target={target} currentTitles={{ task }} task={task}>
            <Card
                data-cy="task-card"
                sx={{ width: 1, py: 1, pt: 2, pb: 1.5, px: 2, mb: 1 }}
                variant="outlined"
                elevation={0}
                raised={false}
            >
                <ListItemBox spacing={3} alignItems="center">
                    <Box width={1 / 4}>
                        <ListItemBox spacing={1} alignItems="center">
                            <ListItemBox spacing={1} alignItems="flex-start">
                                <Box sx={{ color: "primary.main", mt: 0.4 }}>
                                    <Iconify icon="fluent:shield-task-24-filled" />
                                </Box>
                                <Typography component="div" variant="body2">
                                    {task}
                                </Typography>
                            </ListItemBox>

                            <Box flex={1} />

                            <CountEntry
                                count={count}
                                task={task}
                                showOne
                                frequencyPeriod={frequency?.period}
                                frequencyInterval={frequency?.interval}
                                minutes={minutes}
                            />
                        </ListItemBox>
                    </Box>
                    <Box width={1 / 5} maxWidth={160}>
                        <Skills list={list} skills={skills} />
                    </Box>
                    <Box width={1 / 4}>
                        <Schedules schedules={schedules} list={list} />
                    </Box>
                    <Box flex={1}>
                        <Box sx={{ width: 1, mt: -4, mb: -4 }} ref={setPortal}></Box>
                    </Box>
                </ListItemBox>
                <List sx={{ display: rows.length === 1 ? "none" : undefined }}>
                    <Repeat list={rows} item={<Tailorable masterCount={count} onlyOne={rows.length < 2} />} />
                </List>
            </Card>
        </Bound>
    )

    function produceTailoringRows() {
        if (target.schedulesOpen && target.skillsOpen) return list.sortBy("schedule.title")
        if (target.schedulesOpen) return summariseBy(list, (c) => c.schedule._id, "skill").sortBy("schedule.title")
        if (target.skillsOpen) return summariseBy(list, "skill", "schedule", { _id: "", title: "-", code: "" })
        return [{ ...list[0], skill: "-", schedule: { _id: "", title: "-" } }]
    }
}
